import axios from "axios";
// what in the hell
export const api = axios.create({
    baseURL: 'https://dtmoney-jbiers.netlify.app/api'
})